import { configureStore, createAction } from "@reduxjs/toolkit";
import {
  useDispatch as useAppDispatch,
  useSelector as useAppSelector,
} from "react-redux";
import { persistStore, persistReducer } from "redux-persist";
import { rootPersistConfig, rootReducer } from "./rootReducer";
import journalMiddleware from "src/utils/journal/journalMiddleware";
import cartDraftMiddleware from "./middleware/cartDraftMiddleware";
import { pruneCheckoutHistory } from "./slices/product";

// ----------------------------------------------------------------------
// Lista de acciones que no representan interacción del usuario
// const IGNORED_ACTIONS = [
//   "mesas/setSelectedIdMesaSuccess",
//   "product/syncCartCheckoutComplete",
//   "mesas/getMesaSuccess",
//   "order/updateOrderPayment",

//   // Agrega aquí los tipos de acciones que quieres ignorar
// ];

// // Middleware personalizado para filtrar acciones
// const userActivityMiddleware = (storeAPI) => (next) => (action) => {
//   if (!IGNORED_ACTIONS.includes(action.type)) {
//     // Actualiza la última interacción del usuario
//     window.localStorage.setItem("lastAction", new Date().toISOString());
//   }
//   return next(action);
// };

const store = configureStore({
  reducer: persistReducer(rootPersistConfig, rootReducer),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }).concat(journalMiddleware, cartDraftMiddleware),
  //.concat(userActivityMiddleware),
});

// Al restaurar el estado guardado, descartamos borradores de mesa caducados.
const persistor = persistStore(store, null, () => {
  store.dispatch(pruneCheckoutHistory());
});

const { dispatch } = store;

const useSelector = useAppSelector;

const useDispatch = () => useAppDispatch();

export { store, persistor, dispatch, useSelector, useDispatch };
